<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12 lg3 md4 sm6>
        <market-data-separator
          :market="market"
          :data-source="dataSource.counterparties"
          :value="counterparties"
          v-slot="{dataSource: ds, marketValues, selectedValues}"
        >
          <vonap-form-label label="Counterparties">
            <vonap-switch-list
              :use-v-card="false"
              max-height="400px"
              flex-size="xs6"
              :data-source="ds"
              data-value-field="counterpartyId"
              data-text-field="counterpartyName"
              @input="$emit('update:counterparties', selectedValues($event))"
              :value="marketValues"
              width="130px"
            />
          </vonap-form-label>
        </market-data-separator>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import MarketDataSeparator from '../MarketDataSeparator'
import VonapSwitchList from '@/components/VonapSwitchList'
import VonapFormLabel from '@/components/VonapFormLabel'

export default {
  props: ['market', 'dataSource', 'counterparties'],
  components: {
    MarketDataSeparator,
    VonapSwitchList,
    VonapFormLabel,
  },
}
</script>
